import { useSales } from "../../sales/hooks/useSales";
import type { SalesQueryDto } from "../../../api";

export function usePartnerSales(partnerId: number, query?: Omit<SalesQueryDto, "partnerId">) {
  return useSales({ ...query, partnerId });
}
